// extracted by mini-css-extract-plugin
export default {"area_box":"useAgreeModal_area_box__n7wPz"};